import React from 'react';
import PropTypes from 'prop-types';
import { createRefetchContainer, graphql } from 'react-relay';
import { Translate } from '@hydra/common/components';
import get from 'lodash/get';

import H1IssueRow from '../H1IssueRow';
import CrawlerTable from '@hydra/routes/crawler/components/CrawlerTable';

import FilterContainer from '@hydra/routes/crawler/components/FilterContainer';
import FilterCheckboxes from '@hydra/routes/crawler/components/FilterCheckboxes';
import FilterString from '@hydra/routes/crawler/components/FilterString';
import { withFilters } from '@hydra/routes/crawler/components/withFilters';

export class H1IssueTable extends React.Component {
  static propTypes = {
    relay: PropTypes.object,
    project: PropTypes.shape({
      crawls: PropTypes.shape({
        edges: PropTypes.arrayOf(
          PropTypes.shape({
            node: PropTypes.shape({
              countTypesH1Issues: PropTypes.arrayOf(
                PropTypes.shape({
                  count: PropTypes.number,
                  severity: PropTypes.number,
                  type: PropTypes.string
                })
              ),
              h1Issues: PropTypes.shape({
                count: PropTypes.number,
                edges: PropTypes.arrayOf(
                  PropTypes.shape({
                    node: PropTypes.shape({
                      __dataID__: PropTypes.string,
                      severity: PropTypes.number,
                      h1s: PropTypes.array,
                      type: PropTypes.string,
                      url: PropTypes.string
                    })
                  })
                )
              })
            })
          })
        )
      })
    }).isRequired,
    offset: PropTypes.number,
    limit: PropTypes.number
  }

  render () {
    const toggles = get(this.props.project, 'crawls.edges[0].node.countTypesH1Issues', [])
      .map(v => ({ identifier: v.type, ...v }));
    return (
      <>
        <FilterContainer>
          <FilterCheckboxes
            onChange={this.props.onGraphQLCheckboxInputChange('typeFilters', toggles)}
            checkedItems={this.props.filters.typeFilters}
            groups={toggles}
            name='typeFilters'
            label={<Translate content='crawler_h1_tag_issue' />}
          />

          <FilterString
            onChange={this.props.onGraphQLInputChange('h1')}
            value={this.props.filters.h1}
            name='h1'
            label={<Translate content='crawler_h1_tag_text' />}
          />

          <FilterString
            onChange={this.props.onGraphQLInputChange('url')}
            value={this.props.filters.url}
            name='url'
            label={<Translate content='crawler_error_page_url' />}
          />
        </FilterContainer>
        <CrawlerTable {...this.props} category='onpageCategory' section='h1Issues'>
          <CrawlerTable.TableHead>
            <Translate content='crawler_h1_tag_issue' size={{ sm: 3, md: 2 }} />
            <Translate content='crawler_h1_tag_text' size='4' />
            <Translate content='crawler_error_page_url' size={{ sm: 5, md: 6 }} />
          </CrawlerTable.TableHead>
          <CrawlerTable.Body component={H1IssueRow} />
        </CrawlerTable>
      </>
    );
  }
}

const WithFiltersTable = (withFilters)(H1IssueTable);

export default createRefetchContainer(
  WithFiltersTable,
  {
    project: graphql`
    fragment H1IssueTable_project on Project
    @argumentDefinitions(
      offset: {type: "Int", defaultValue: 0},
      limit: {type: "Int", defaultValue: 20},
      typeFilters: {type: "[String]", defaultValue: []},
      h1: {type: "TextFilters", defaultValue: { operator: AND, values: [] }},
      url: {type: "TextFilters", defaultValue: { operator: AND, values: [] }}
    ) {
      host,
      crawls (offset: 0, limit: 1) {
        edges {
          node {
            countTypesH1Issues(h1: $h1, url: $url) {
              type
              severity
              count
            },
            h1Issues(offset: $offset, limit: $limit, typeFilters: $typeFilters, url: $url, h1: $h1) {
              count
              edges {
                node {
                  ...H1IssueRow_issue
                }
              }
            }
          }
        }
      }
    }
  `
  },
  graphql`
      query H1IssueTable_RefetchQuery(
        $h1: TextFilters,
        $host: String!,
        $limit: Int,
        $offset: Int,
        $typeFilters: [String],
        $url: TextFilters
      ) {
        project (host: $host) {
          ...H1IssueTable_project @arguments(
            offset: $offset,
            limit: $limit,
            typeFilters: $typeFilters,
            url: $url,
            h1: $h1
          )
        }
      }
    `
);
